import API from "utils/axiosHelper";

export const GET_SELECT_OPTIONS = () => {
  return API.get("/form/registration");
};

export const LOGIN = (data) => {
  return API.post("/user/login", data);
};

export const REGISTER = (data) => {
  return API.post("/user/register", data);
};

export const VERIFY_OTP = (data) => {
  return API.post("/user/verify_otp", data);
};

export const UPLOAD_FILE = ({ file }) => {
  const formData = new FormData();
  formData.append("file", file);
  return API.post("/res/upload?folder=quotations", formData);
};

export const SUBMIT_QUOTATIONS = (data) => {
  return API.post("/quotation/submit", data);
};

export const GET_USER_DATA = () => {
  return API.get("/user");
};
